import React, { useContext, useEffect, useRef, useState } from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import AdminSlotCard from './AdminSlotCard'
import AdminSlotPage from './AdminSlotPage'
import { useNavigate, useParams, useBlocker } from 'react-router-dom'
import { get, post } from '../../Common/api'
import dayjs from 'dayjs'
import { useForm } from 'antd/es/form/Form'
import GlobalContext from '../GlobalContext'
import { Modal } from 'antd'
import { t } from 'i18next'

export default function AdminSlot () {
  const { id } = useParams()
  const params = new URLSearchParams(location.search)
  const from = params.get('from')
  const [slot, setSlot] = useState()
  const [loading, setLoading] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const isDirtyRef = useRef(isDirty)
  const navigate = useNavigate()
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  const blocker = useBlocker(isDirty)

  useEffect(() => {
    isDirtyRef.current = isDirty
  }, [isDirty])

  // Afficher le modal quand la navigation est bloquée
  useEffect(() => {
    if (blocker.state === 'blocked') {
      Modal.confirm({
        title: t('Admin.FeedbackForm.unsavedChangesTitle'),
        content: t('Admin.FeedbackForm.unsavedChangesContent'),
        okText: t('Admin.btn.leave'),
        cancelText: t('Admin.btn.stay'),
        onOk: () => blocker.proceed(),
        onCancel: () => blocker.reset()
      })
    }
  }, [blocker])

  // Bloquer le rafraîchissement de page
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirtyRef.current) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [])

  useEffect(() => {
    setLoading(true)
    getSlot()
    setLoading(false)
  }, [])

  const screens = useBreakpoint()

  const getSlot = async () => {
    await get({
      url: `admin/slots/${id}`,
      params: {},
      onSuccess: (json) => { setSlot(json) }
    })
  }

  const cancel = () => {
    setLoading(true)
    post({
      url: `admin/slots/${id}/cancel`,
      params: {},
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        setSlot(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const delay = () => {
    setLoading(true)
    post({
      url: `admin/slots/${id}/delay`,
      params: {},
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        setSlot(json)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const back = () => {
    if (from === 'list') {
      navigate(`/admin/slots?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else if (from === 'calendar') {
      navigate(`/admin/boxes/${slot.box.id}/calendar?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else {
      navigate('/admin/events')
    }
  }

  return (
    <>
    {!screens.lg && slot && <AdminSlotCard form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} setIsDirty={setIsDirty} />}
    {screens.lg && slot && <AdminSlotPage form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} setIsDirty={setIsDirty} />}
    </>
  )
}
